<p-message
    [id]="id() + '-message'"
    [severity]="severity()"
    [icon]="icon()"
    [closable]="closeable()"
    [styleClass]="variant()">
    @if (text()) {
        @if (innerHtml()) {
            <span [innerHTML]="text()"></span>
        } @else {
            {{ text() | translate }}
        }
    }
    <ng-content></ng-content>
</p-message>
